import { useEffect, useState } from "react";
import { IDropdown, ILead } from "../../models/BaseModel";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { useRef } from "react";
import { Dialog } from "primereact/dialog";
import { Accordion, AccordionTab } from "primereact/accordion";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVInput } from "../../shared/JVInput";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { Fetch } from "../../shared/Fetch";
import { JVDate } from "../../shared/JVDate";
import { format } from "date-fns";
import { confirmDialog } from "primereact/confirmdialog";
import { JVCheckbox } from "../../shared/JVCheckbox";
import { IOpenForm } from "./MyLead";

interface Iprops {
    singleData: ILead,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    hasPermission: (pageName: string, featureName?: string) => boolean,
    reloadData: () => void,
}

export interface IEmptyDevice {
    macAddress: "",
    device_Name: null
};

const schema = yup.object({});

interface IPlanDrop extends IDropdown {
    plan_Cost?: number
}

export const AddDevice = (props: Iprops) => {
    const toast = useRef(null);
    const [tableData, setTableData] = useState({ data: [], count: 0, leadDetails: 0, loading: false, status: [] } as { data: ILead[], count: number, leadDetails: number, loading: boolean, status: { id: number, name: string, count: number }[] });
    const [device, setDevice] = useState<IDropdown[]>();
    const [editRow, setEditRow] = useState<ILead | null>(null);
    const [plan, setPlan] = useState<IPlanDrop[]>();
    const [historyModal, setHistoryModal] = useState({ singleData: {}, open: false } as IOpenForm);
    const [tableData1, setTableData1] = useState({ data: [], loading: false } as { data: any[], loading: boolean });

    const { control, handleSubmit, formState: { errors }, reset, watch, setValue } = useForm<any>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false,
    });

    const requirementDetails = watch("status_ID");
    const extraDeal = watch("isExtraDeal");
    const planName = watch("plan_ID");
    const noOfConnections = watch("no_Of_Connections") || 0;
    const planCost = plan?.find((item) => item.id === planName)?.plan_Cost || 0;
    setValue("base_Price", planCost);

    const onHide = () => {
        props.hideDialog();
    }

    const loadTableData = async () => {
        setTableData((prev) => ({ ...prev, loading: true }));
        const response = await Fetch(`Leads/getAttachDeviceById${props.singleData.id ? '/' + props.singleData.id : ''}`, "GET", null, null, props.toast);
        if (response) {
            const data: { data: ILead[], count: number, leadDetails: number, status: { id: number, name: string, count: number }[] } = await response.json();
            setTableData({ data: data.data, count: data.count, status: data.status, loading: false, leadDetails: data.leadDetails });
        } else {
            setTableData((prev) => ({ ...prev, loading: false }));
        }
    }

    const updateRequirementToDB = async (body: ILead) => {
        body.lead_ID = props.singleData.id;
        body.plan_Name = props.singleData.plan_Name;
        const response = await Fetch(`Leads/AddOrUpdateLeadRequirement`, "POST", body, null, props.toast);
        if (response) {
            const resData = await response.json();
            props.toast.current.show({ severity: 'success', detail: resData.message, life: 3000 });
            props.reloadData();
            loadTableData();
        }
    };

    const saveToDB = async (body: ILead) => {
        let endpoint = `Leads/AddAttachDevice/${props.singleData.id}`;
        if (editRow?.id) {
            endpoint = `Leads/UpdateAttachDevice/${editRow.id}`;
        }
        const response = await Fetch(endpoint, "POST", body, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: editRow?.id ? "Updated Successfully" : "Added Successfully", life: 3000 });
            reset({ macAddress: "", device_Name: null, plan_ID: null, base_Price: 0, deal_Price: null, expectedActivationDate: null, extraNoOfDays: null });
            setEditRow(null);

            loadTableData();
            props.reloadData();
        }
    }

    const onSubmit = (type: "requirement" | "device") => (data: ILead) => {
        const body = {
            ...data,
            expectedActivationDate: data.expectedActivationDate ? format(new Date(data.expectedActivationDate), 'yyyy-MM-dd') : null
        } as any;

        if (type === "device") {
            if (Number(data.deal_Price) > Number(data.base_Price)) {
                props.toast.current.show({
                    severity: 'error',
                    detail: "Deal Price cannot be greater than Base Price",
                    life: 3000,
                });
                return;
            }
            if ((!editRow?.id) && tableData.count === tableData.leadDetails) {
                props.toast.current.show({
                    severity: 'error',
                    detail: "Please Update No. Of Connection First",
                    life: 3000,
                });
            } else {
                saveToDB(body);
            }
        } else if (type === "requirement") {
            updateRequirementToDB(body);
        }
    };

    const onEdit = (rowData: any) => {
        setEditRow(rowData);
        reset({
            ...rowData,
            expectedActivationDate: rowData.expectedActivationDate ? new Date(rowData.expectedActivationDate) : null,
        });
    };

    useEffect(() => {
        if (props.open) {
            loadTableData();
        }
    }, [props.open]);

    const loadDevice = async () => {
        const response = await Fetch("device/dropdown", "GET", null, null, null);
        if (response) setDevice(await response.json());
    }

    const loadPlan = async () => {
        const response = await Fetch("subscription_Plan/dropdown", "GET", null, null, null);
        if (response) setPlan(await response.json());
    }

    useEffect(() => {
        reset(props.singleData);
    }, [props.singleData]);

    useEffect(() => {
        loadDevice();
        loadPlan();
    }, []);

    const rejectFunc = () => { }

    const Remove = async (rowData: any) => {
        setTableData((prev) => ({ ...prev, loading: true }));
        const response = await Fetch(`Leads/deleteAttachDevice/${rowData.id}`, "DELETE", null, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Deleted", life: 3000 });
            loadTableData();
        }
    }

    const confirmDelete = (rowData: any) => {
        confirmDialog({
            message: `Are you sure you want to delete "${rowData.device_Name}"?`,
            header: 'Confirm Delete',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            accept: () => Remove(rowData),
            reject: () => rejectFunc()
        });
    }

    const actionBodyTemplate = (rowData: any) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-text p-button-sm" onClick={() => onEdit(rowData)} tooltip="Edit" />
                <Button icon="pi pi-trash" className='p-button-danger p-button-text p-0' onClick={() => { confirmDelete(rowData) }} />
                {rowData.isHistoryCreate === true && (
                    <Button
                        icon="pi pi-history"
                        className='p-button-info p-button-text p-0'
                        tooltip="View History"
                        tooltipOptions={{ position: 'top' }}
                        onClick={() => {
                            setHistoryModal({ singleData: rowData, open: true });
                            loadTableData1(rowData.id);
                        }}
                    />
                )}
            </div>
        );
    };

    const loadTableData1 = async (id: number) => {
        setTableData1((prev) => ({ ...prev, loading: true }));
        const response = await Fetch(`leads/deviceupdateHistory/${id}`, "GET", null, null, props.toast);
        if (response) {
            const data: { leadHistory: any } = await response.json();
            setTableData1({ data: data.leadHistory, loading: false });
        } else {
            setTableData1((prev) => ({ ...prev, loading: false }));
        }
    }

    const onHideHistory = () => {
        setHistoryModal({ singleData: {}, open: false });
    }

    const Clear = () => {
        setEditRow(null);
        reset({ macAddress: "", device_Name: null, plan_ID: null, base_Price: 0, deal_Price: null, expectedActivationDate: null, extraNoOfDays: null });
    }

    const connectionEABody = (rowData: any) => (
        <span>{rowData.expectedActivationDate ? format(new Date(rowData.expectedActivationDate), 'dd/MM/yyyy') : '-'}</span>
    );
    const eAdate = (rowData: any) => (
        <span>{rowData.expectedActivationDate ? format(new Date(rowData.expectedActivationDate), 'dd/MM/yyyy') : '-'}</span>
    );

    const connectionStartDate = (rowData: any) => (
        <span>{rowData.connectionStartDate ? format(new Date(rowData.connectionStartDate), 'dd/MM/yyyy') : '-'}</span>
    );

    const connectionStopDate = (rowData: any) => (
        <span>{rowData.connectionStopDate ? format(new Date(rowData.connectionStopDate), 'dd/MM/yyyy') : '-'}</span>
    );

    return (
        <>
            <Dialog visible={props.open} style={{ width: '80vw' }} header={``} modal className="p-fluid" onHide={onHide}>
                <Accordion multiple activeIndex={[1]}>
                    <AccordionTab header="Update Requirements" className="w-full">
                        <form onSubmit={handleSubmit(onSubmit("requirement"))} className="p-fluid formgrid grid">
                            <JVInput column={3} label="No. Of Connection" control={control} name="no_Of_Connections" />
                            <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                                <Button style={{ width: '100px' }} label="SAVE" type="submit" className="p-button-rounded" />
                            </div>
                        </form>
                    </AccordionTab>

                    <AccordionTab header="Add Device" className="w-full">
                        <h3>{editRow?.id
                            ? `Editing Device — ${tableData.count} of ${tableData.leadDetails} Connections Added`
                            : `Add a New Device — ${tableData.count} of ${tableData.leadDetails} Connections Added`}
                        </h3>

                        <form onSubmit={handleSubmit(onSubmit("device"))} className="p-fluid formgrid grid">
                            <JVDropdown column={6} label="Select Device" control={control} options={device} optionLabel="device_Name" optionValue="id" name="device_ID" placeholder="Select Device" />
                            <JVInput column={6} label="Mac Address" control={control} name="macAddress" />
                            <JVDropdown column={6} label="Select Plan" control={control} options={plan} optionLabel="plan_Name" optionValue="id" name="plan_ID" placeholder="Select Plan" />
                            <JVInput column={6} label="Base Price($)" control={control} name="base_Price" type="number" disabled />
                            <JVInput column={6} label="Deal Price($)" control={control} name="deal_Price" type="number" />
                            {extraDeal && <JVInput column={6} label="Extra No. Of Days" control={control} name="extraNoOfDays" type="number" />}
                            <JVDate column={6} label="EA Date" control={control} name="expectedActivationDate" tooltip="Expected Activation Date – choose the date device should activate" />
                            <div className="col-span-12 flex justify-end gap-3 mt-4 ml-2">
                                <Button className="h-3rem w-6rem" type="submit">{editRow?.id ? "UPDATE" : "SUBMIT"}</Button>
                                <Button className="h-3rem w-6rem p-button-outlined" type="button" onClick={Clear}>CLEAR</Button>
                            </div>
                        </form>

                        <div style={{ marginTop: '10px', marginBottom: '20px', width: '100%' }}></div>

                        <DataTable
                            style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                            size="small"
                            value={tableData.data}
                            emptyMessage="No Data found."
                            loading={tableData.loading}
                        >
                            <Column field="device_Name" header="Device Name" />
                            <Column field="plan_Name" header="Plan Name" />
                            <Column field="base_Price" header="Base Price" />
                            <Column field="deal_Price" header="Deal Price" />
                            <Column field="macAddress" header="Mac Address" />
                            <Column field="createdByName" header="Created By" />
                            <Column field="created_at" header="Created At" body={(rowData) => format(new Date(rowData.created_at + "Z"), 'dd/MM/yyyy')} />
                            <Column field="expectedActivationDate" header="EA Date" body={eAdate} sortable />
                            <Column header="Action" body={actionBodyTemplate} />
                        </DataTable>
                    </AccordionTab>
                </Accordion>

                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200" />
                </div>
            </Dialog>

            <Dialog visible={historyModal.open} style={{ width: '60vw' }} header="Device Update History" modal className="p-fluid" onHide={onHideHistory}>
                <DataTable
                    style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                    size="small" stripedRows scrollHeight="50vh"
                    value={tableData1.data}
                    loading={tableData1.loading}
                >
                    <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                    <Column field="device_Name" header="Device" sortable />
                    <Column field="plan_Name" header="Plan" sortable />
                    <Column field="macAddress" header="Mac Address" sortable />
                    <Column field="expectedActivationDate" header="EA Date" sortable body={connectionEABody} />
                    <Column field="base_Price" header="Base Price" sortable />
                    <Column field="deal_Price" header="Deal Price" sortable />
                    <Column field="connectionStartDate" header="Connection Start Date" sortable body={connectionStartDate} />
                    <Column field="connectionStopDate" header="Connection Stop Date" body={connectionStopDate} sortable />
                </DataTable>
            </Dialog>
        </>
    );
};
